import { Reducer } from 'react';
import { CLEAR_PRIO_CACHE } from '../../../actions';
import { combineReducers } from 'redux';
import {
  UPDATE_MAIL_COMPONENTS_ZOOM_FACTOR,
  UPDATE_MAIL_COMPONENTS_ZOOM_PANEL_PINNED_STATE,
} from '../actions/components';

export interface MailComponentsState {
  zoomFactor: number;
  zommPanelPinned: boolean;
}

const initialState: MailComponentsState = {
  zoomFactor: 1.0,
  zommPanelPinned: false,
};

const zoomFactor: Reducer<number, any> = (
  state = initialState.zoomFactor,
  action
) => {
  switch (action.type) {
    case UPDATE_MAIL_COMPONENTS_ZOOM_FACTOR: {
      return action.payload;
    }

    case CLEAR_PRIO_CACHE: {
      return initialState.zoomFactor;
    }
    default:
      return state;
  }
};

const zommPanelPinned: Reducer<boolean, any> = (
  state = initialState.zommPanelPinned,
  action
) => {
  switch (action.type) {
    case UPDATE_MAIL_COMPONENTS_ZOOM_PANEL_PINNED_STATE: {
      return action.payload;
    }

    case CLEAR_PRIO_CACHE: {
      return initialState.zoomFactor;
    }
    default:
      return state;
  }
};

export default combineReducers({
  zoomFactor,
  zommPanelPinned,
});

export const getZoomFactor = (state: MailComponentsState): number => {
  return state.zoomFactor;
};

export const getZoomPanelPinnedState = (
  state: MailComponentsState
): boolean => {
  return state.zommPanelPinned;
};
